import { render, staticRenderFns } from "./word-sheet.vue?vue&type=template&id=1728ecf8&scoped=true&"
import script from "./word-sheet.vue?vue&type=script&lang=js&"
export * from "./word-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728ecf8",
  null
  
)

export default component.exports